import request from '@/plugins/request'

const API = {
  current: '/student/pc/certExempt/current',
  submit: '/student/pc/certExempt/submit',
  resubmit: '/student/pc/certExempt/resubmit',
  examBatchSelect: '/student/pc/certExempt/examBatch/select'
}

/**
 * 查询1+X申免页面初始化信息
 * @param {string} examBatchId 考次ID，非必填，必要时传空即可
 */
export function getCertExemptCurrent(examBatchId) {
  return request.get(API.current, { examBatchId: examBatchId || '' })
}

/**
 * 考次下拉
 * @returns {Promise<Array>} 考次列表 [{ batchId, batchName, examTimeCode, submitStartTime, submitEndTime }]
 */
export function getExamBatchSelect() {
  return request.get(API.examBatchSelect)
}

/**
 * 提交证书材料（首次提交）
 * @param {object} data
 * @param {string} data.certNo 证书编号，页面必填
 * @param {string} data.batchId 批次/考次ID，取自页面考次下拉选择
 * @param {string} data.certPhotoUrl 证书图片URL，由公共上传接口返回
 */
export function submitCertExempt(data) {
  return request.post(API.submit, data)
}

/**
 * 打回修改后重新提交
 * @param {object} data
 * @param {string} data.id 申请记录主键ID
 * @param {string} data.certNo 修改后的证书编号，页面必填
 * @param {string} data.certPhotoUrl 重新上传后的证书图片URL，由公共上传接口返回
 */
export function resubmitCertExempt(data) {
  return request.post(API.resubmit, data)
}
